export function isSpectrum1D(spectrum) {
    return spectrum.info.dimension === 1;
}
